import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Sidebar from 'layouts/AppLayout/components/Sidebar';
import SimpleAlert from 'components/Alert';
import { MainContainer, MainWrapper, WrapperWithOverflow } from 'layouts/AppLayout/styled';

const Layout = () => {
  return (
    <Box>
      <MainContainer >
        <Sidebar />
        <WrapperWithOverflow>
          <SimpleAlert />
          <MainWrapper>
            <Outlet />
          </MainWrapper>
        </WrapperWithOverflow>
      </MainContainer>
    </Box>
  );
};

export default Layout;

